import jQuery from 'jquery'
window.jQuery = window.$ = jQuery

$(function(){

    // $(window).bind("resize scroll",function(e){
    //     var width = $(window).outerWidth();
    //     var scroll = $(window).scrollTop();
    //     if (scroll >= 1 && width > 991.98) {
    //         $(".header-logo").addClass("header-logo-scroll");
    //         $(".header").addClass("header-scroll");
    //         $(".header-links").addClass("header-links-scroll");
    //         $(".hero").addClass("hero-scroll");
    //         if ($(".main-page".length)) {
    //             $(".main-page").addClass("main-page-scroll");
    //         }
    //     } else {
    //         $(".header-logo").removeClass("header-logo-scroll");
    //         $(".header").removeClass("header-scroll");
    //         $(".header-links").removeClass("header-links-scroll");
    //         $(".hero").removeClass("hero-scroll");        
    //         if ($(".main-page".length)) {
    //             $(".main-page").removeClass("main-page-scroll");
    //         }
    //     }
    //     if (width > 991.98) {
    //         if ($(".mobile-menu-button").hasClass("active")) {
    //             $(".mobile-menu-button").toggleClass("inactive active")
    //             $(".mobile-menu").toggle("slide", {direction: "right"}, 1);
    //         }
    //     }
    // });

    $(".mobile-menu-close-button").click(function(){
        $(".mobile-menu-button").toggleClass("inactive active")
        $(".mobile-menu").toggle("slide", {direction: "right"}, 300);
    });

    $(".mobile-menu-button").on('click', function () {
      $(this).toggleClass("inactive active")
      $(".mobile-menu").toggle("slide", {direction: "right"}, 300);
    });

    $(".mobile-menu-content a").on('click', function () {
        $(".mobile-menu-button").toggleClass("inactive active")
        $(".mobile-menu").toggle();
    });

    $(".header-logo").on('click', function () {
        if ($(".mobile-menu-button").hasClass("active")) {
            $(".mobile-menu-button").toggleClass("inactive active")
            $(".mobile-menu").toggle();
        }
    });
    
});